// Semantic intent tokens — one source of truth for danger, warning, success, partner colors.
// Parallel objects (dark / light) consistent with theme.js pattern.

export const DARK_TOKENS = {
  // Danger (red) — overdue badges, delete buttons, errors, urgent
  danger:         "#D46060",
  dangerMuted:    "#c06060",
  dangerBg:       "rgba(212,96,96,0.15)",
  dangerBgSubtle: "rgba(212,96,96,0.08)",
  dangerBgGlow:   "rgba(212,96,96,0.10)",
  dangerBorder:   "rgba(212,96,96,0.5)",
  dangerBorderLo: "rgba(212,96,96,0.3)",
  dangerSurface:  "#5a1010",   // delete button bg
  dangerSurface2: "#7a1a1a",  // confirm-delete / bulk-delete bg
  dangerText:     "#ff9999",   // delete button label
  dangerText2:    "#ffaaaa",   // confirm-delete label

  // Warning (amber) — monitoring badges, negative connection time, progress bars, import alerts
  warning:        "#c8a830",
  warningBorder:  "#7a6a00",
  warningBg:      "rgba(200,168,48,0.08)",
  warningBgSubtle:"rgba(200,168,48,0.12)",

  // Success (green) — boarded/confirmed saved state, PAX/bags progress bar at 100%
  success:        "#6EC472",
  successMuted:   "#8fbf8f",
  successAlt:     "#6abf6a",    // progress bar fill
  successSurface: "#0d1a0d",   // saved-airline button bg
  successBorder:  "#4a7a4a",   // saved-airline button border

  // Partner (blue) — partner airline tray & expand buttons
  partner:        "#88aadd",
  partnerSurface: "#1a2a4a",
  partnerBorder:  "rgba(100,140,220,0.35)",

  // Monospace text roles
  monoGreen:      "#8fbf8f",
  monoPurple:     "#8888cc",
  monoRed:        "#c06060",
};

export const LIGHT_TOKENS = {
  danger:         "#C62828",
  dangerMuted:    "#C62828",
  dangerBg:       "rgba(198,40,40,0.10)",
  dangerBgSubtle: "rgba(198,40,40,0.06)",
  dangerBgGlow:   "rgba(198,40,40,0.08)",
  dangerBorder:   "rgba(198,40,40,0.40)",
  dangerBorderLo: "rgba(198,40,40,0.25)",
  dangerSurface:  "#fef2f2",
  dangerSurface2: "#fee2e2",
  dangerText:     "#C62828",
  dangerText2:    "#B91C1C",

  warning:        "#B45309",
  warningBorder:  "#D97706",
  warningBg:      "rgba(180,83,9,0.08)",
  warningBgSubtle:"rgba(180,83,9,0.12)",

  success:        "#2E7D32",
  successMuted:   "#4CAF50",
  successAlt:     "#4CAF50",
  successSurface: "#f0faf0",
  successBorder:  "#76b87a",

  partner:        "#1565C0",
  partnerSurface: "#e3f2fd",
  partnerBorder:  "rgba(21,101,192,0.30)",

  monoGreen:      "#2E7D32",
  monoPurple:     "#3949AB",
  monoRed:        "#C62828",
};

// Spacing scale — use for padding, gap, and margin.
// xs=4  sm=8  md=12  lg=16  xl=20  xxl=24  xxxl=32
export const SPACING = {
  xs:   4,
  sm:   8,
  md:   12,
  lg:   16,
  xl:   20,
  xxl:  24,
  xxxl: 32,
};

// Typography scale — font sizes for each semantic role.
// tiny=9  label=10  body=12  sub=14  header=17
export const TYPOGRAPHY = {
  tiny:    9,
  label:   10,
  caption: 11,
  body:    12,
  note:    13,
  sub:     14,
  header:  17,
};

// Border radius scale — five tiers + circle.
// sharp=4  sm=8  md=10  card=14  pill=20  circle="50%"
export const RADIUS = {
  sharp:  4,
  sm:     8,
  md:     10,
  card:   14,
  pill:   20,
  circle: "50%",
};
